module.exports = __webpack_public_path__ + "img/dashuju.fee27912.png";